module.exports = __webpack_public_path__ + "img/puzzle.b8054b.svg";